import React, { Component } from 'react';
import { loadingStart, loadingStop } from '@core/store/modules/loading/loading.slice';
import { IconButton, Icon, Button, Container, Box, Typography, TextField } from '@mui/material';
import { saveAs } from 'file-saver';
import Grid from '@mui/material/Grid2'
import { Scrollbars } from 'react-custom-scrollbars-2';
import { fixImageOrientation } from 'FielderUtils/fixImageOrientation'
import { connect } from 'react-redux';
import { ENDPOINTS } from '../../core/constants/pageEndpoints.constants';
import { isRoleValid } from '../../core/utils/roles/validateRoles';
import { DeepSpaceGrey } from '@core/theme/baseTheme';
import { PDF_SECRECT_KEY } from 'FielderUtils/session/Session';
import {
	reactivateFormRequest,
	updateTaskFormPdfRequest,
	uploadTaskFormPdfRequest,
	getXLSXOrHTMLFromFormRequest,
	getFormHTMLRequest,
	getPdfFromHtmlRequest
} from '@core/api/form/form.service';
import { getInventoryHTMLRequest } from '@core/api/inventory/inventory.service';
import { getAssetHTMLRequest } from '@core/api/asset/asset.service';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PartnerIcon from '@assets/icons/partner-icon.svg';
import Tooltip from '@mui/material/Tooltip';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import SuccessIcon from '@assets/icons/success-alert-icon.svg';
import ErrorIcon from '@assets/icons/alert-icon.svg';
import Types from 'FielderUtils/forms/types';
import assetConst from 'FielderUtils/roleManagementConst/assetConst';
import formConst from 'FielderUtils/roleManagementConst/formConst';
import inventoryConst from 'FielderUtils/roleManagementConst/inventoryConst';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import moment from 'moment';
import LoadingConst from 'OldComponents/Loading/LoadingConst';
import EditForm from './EditForm';
import GeneratePdfFromXlsx from './GeneratePdfFromXlsx';
import ReactivateForm from './ReactivateForm';
import RemoveFormPopup from './RemoveFormPopup';
import TaskAssets from './TaskAssets';
import TaskInventories from './TaskInventories';
import UpdateFileMenu from './UpdateFileMenu';
import UpdateDocumentMessage from './UpdateDocumentMessage';
import ExportIcon from '@assets/icons/import-icon.svg';
import ErrorMessage from 'OldComponents/ErrorMessage/ErrorMessage';
import withRouter from '~/withRouter/withRouter.component';
import uploadButton from '@assets/icons/export-icon.svg';
import DowloadFormTemplate from 'OldComponents/Forms/DowloadFormTemplate';
import presignedUrlForUpload from '@core/utils/aws/s3/presignedUrlForUpload';
import './TaskDetails.css';
import { SmartTitleTypography } from '~/FielderElements/SmartTaskTable/SmartStyles';
import { getTaskModulesFieldQuestion } from 'OldComponents/TaskDetails/util';

const _ = require('lodash');
const BUCKET_NAME_KEY = 'servicesPdfConverter';
const ACL = 'public-read';
const ACCEPT_FILES = '.pdf';

class OrientedImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orientedUrl: null,
    };
  }
  componentDidMount() {
    this.fixOrientation(this.props.src);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) this.fixOrientation(this.props.src);
  }
  async fixOrientation(src) {
    try {
      const response = await fetch(src);
      const blob = await response.blob();
      const headerType = response.headers.get('content-type');
      const mimeType = (blob.type || headerType || '').toLowerCase();
      const supportsExif = ['image/jpeg', 'image/jpg', 'image/pjpeg', 'image/tiff'].includes(mimeType);
      if (supportsExif) {
        const fixedUrl = await fixImageOrientation(blob);
        this.setState({ orientedUrl: fixedUrl });
      } else {
        const fallbackUrl = typeof src === 'string' ? src : URL.createObjectURL(blob);
        this.setState({ orientedUrl: fallbackUrl });
      }
    } catch (err) {
      console.error('Error fixing image orientation', err);
      this.setState({ orientedUrl: src });
    }
  }
  render() {
    const { orientedUrl } = this.state;
    const { style = {} } = this.props;
    if (!orientedUrl) return null;
    return <img src={orientedUrl} alt='' style={style} />;
  }
}
class TaskModules extends Component {
	constructor(props) {
		super(props);
		this.state = {
			view: {
				assets: false,
				inventory: false,
				forms: false,
				assetsFields: [],
			},
			forms: [],
			assets: [],
			inventory: [],
			activeInventory: 0,
			activeAsset: 0,
			activeForm: 0,
			formHasImages: false,
			assetHasImages: false,
			inventoryHasImages: false,
			formImages: [],
			showFormFile: {},
			assetImages: [],
			inventoryImages: [],
			formsFunctionalities: {
				excel: false,
				html: false,
			},
			show: {
				editForm: false,
				editAsset: false,
				editInventory: false,
				generatePdfFromXlsx: false,
				reactivateForm: null,
				removeTaskForm: null,
			},
			updated: 0,
			isAllowedToDeleteTaskForm:  isRoleValid(formConst.FORMS, formConst.DELETE_TASK_FORM, this.props.session.roles),
			isAllowedToViewInventory: isRoleValid(inventoryConst.INVENTORY, inventoryConst.VIEW,this.props.session.roles),
			isAllowedToDownloadForms:  isRoleValid(formConst.FORMS,	formConst.DOWNLOAD_TASK_FORM,this.props.session.roles),
			isAllowedToViewForm:  isRoleValid(formConst.FORMS, formConst.VIEW_TEMPLATES, props.session.roles),
			isAllowedToViewAsset: isRoleValid(assetConst.ASSETS, assetConst.VIEW, props.session.roles),
			isAllowedToEditTask: isRoleValid(formConst.FORMS, formConst.EDIT_TASK_FORM, props.session.roles),
			allowManagerToDownloadFormExcelTaskDetail:  !!props?.session?.accountPreferences?.allowManagerToDownloadFormExcelTaskDetail,
			allowManagerToEditFormTaskDetail: !!props?.session?.accountPreferences?.allowManagerToEditFormTaskDetail,
			allowManagerToApproveForms: !!props?.session?.accountPreferences?.allowManagerToApproveForms,
			showPdfConverter: !!props?.session?.accountPreferences?.showPdfConverter,

			disablePdfTemplateButton: false,
			showUpdateComponentPdf: false,
			urlFromPdf: null,
			idFilePdf: 0,
			showUpdateMessage: false,
			//Update PDF
			fileUpdate: null,
			fileNameUpdate: null,
			idAccountFileUpdate: null,
			originalIdFile: null,
			originalFileKey: null,
			
			messageApproved: props.lan.pdfAprovedMessage,
			iconMessage: SuccessIcon,
			viewImport: false,

			
		};
		console.log('this.getAllowPartnerDownloadTemplatePdf()', this.getAllowPartnerDownloadTemplatePdf() );
	}
	static getDerivedStateFromProps(nextProps, prevState) {
		let change = {};
		if (nextProps.forms) {
			if (nextProps.forms.length !== prevState.forms?.length) {
				change.forms = nextProps.forms;
				change.activeForm = 0;
			}
		}
		if (nextProps.assets) {
			if (nextProps.assets.length !== prevState.assets.length) {
				change.assets = nextProps.assets;
				change.activeAsset = 0;
			}
		}
		if (nextProps.inventories) {
			if (nextProps.inventories.length !== prevState.inventory.length) {
				change.inventory = nextProps.inventories;
				change.activeInventory = 0;
			}
		}
		if (!_.isEmpty(change)) {
			return change;
		} else if (nextProps.updated != prevState.updated) {
			return {
				updated: nextProps.updated,
				forms: nextProps.forms,
				assets: nextProps.assets,
				inventory: nextProps.inventories,
			};
		}
		return null;
	}
	checkCustomTemplate(forms) {
		let xlsxFunc = false;
		let htmlFunc = false;
		let state = this.state;
		if (forms.templatePath) {
			switch (forms.templateType) {
				case 'xlsx':
					xlsxFunc = true;
					break;
				case 'html':
					htmlFunc = true;
					break;
				default:
					break;
			}
		}
		state.formsFunctionalities = {
			excel: xlsxFunc,
			html: htmlFunc,
		};
		this.setState(state);
	}
	checkPdfUpload = (forms) => {
		let disablePdfTemplateButton = false;
		let showUpdateComponentPdf = false;
		let urlFromPdf = null;
		let idFilePdf = 0;
		if (this.props.taskData && this.props.taskData.serviceFilesPdf) {
			for (let i = 0; i < this.props.taskData.serviceFilesPdf.length; i++) {
				let serviceFilesPdf = this.props.taskData.serviceFilesPdf[i];
				if (serviceFilesPdf.idTaskForm == forms.idTaskForm) {
					disablePdfTemplateButton = true;
					showUpdateComponentPdf = true;
					urlFromPdf = serviceFilesPdf.fileUrl;
					idFilePdf = serviceFilesPdf.idFilePdf;
					break;
				}
			}
		}
		let state = this.state;
		state.disablePdfTemplateButton = disablePdfTemplateButton;
		state.showUpdateComponentPdf = showUpdateComponentPdf;
		state.urlFromPdf = urlFromPdf;
		state.idFilePdf = idFilePdf;
		this.setState(state);
	};
	changeView = (viewName) => {
		var view = { ...this.state.view };
		if (viewName === 'forms' && this.state.forms.length > 0) {
			view.forms = !view.forms;
			view.assets = false;
			view.inventory = false;
			this.changeActiveForm(0);
		} else if (viewName === 'assets' && this.state.assets.length > 0) {
			view.assets = !view.assets;
			view.forms = false;
			view.inventory = false;
			this.changeActiveAsset(0);
		} else if (viewName === 'inventory' && this.state.inventory.length > 0) {
			view.inventory = !view.inventory;
			view.assets = false;
			view.forms = false;
			this.changeActiveInventory(0);
		}
		this.setState({ view });
	};
	getShowViewForm = () => {
		const { forms, session } = this.props;
		const { activeForm } = this.state;
		const form = forms[activeForm];

		if (form && form.accountId === session.user.idAccount) return true;
		else false;
	}
	getAllowPartnerGenerateXlsxForm = () => {
		const { forms, session, allowPartnerGenerateXlsxForm } = this.props;
		const { activeForm } = this.state;
		const form = forms[activeForm];

		if (form && form.accountId === session.user.idAccount) return true;
		else if (form && form.accountId !== session.user.idAccount) return allowPartnerGenerateXlsxForm;
		else return true;
	}
	getAllowPartnerGenerateTemplatePdf = () => {
		const { forms, session, allowPartnerGenerateTemplatePdf } = this.props;
		const { activeForm } = this.state;
		const form = forms[activeForm];

		if (form && form.accountId === session.user.idAccount) return true;
		else if (form && form.accountId !== session.user.idAccount) return allowPartnerGenerateTemplatePdf;
		else return true;
	}
	getAllowPartnerGenerateTemplatePdfFielder = () => {
		const { forms, session, allowPartnerGenerateTemplatePdfFielder } = this.props;
		const { activeForm } = this.state;
		const form = forms[activeForm];

		if (form && form.accountId === session.user.idAccount) return true;
		else if (form && form.accountId !== session.user.idAccount) return allowPartnerGenerateTemplatePdfFielder;
		else return true;
	}
	getAllowPartnerUpdateTemplatePdf = () => {
		const { forms, session, allowPartnerUpdateTemplatePdf } = this.props;
		const { activeForm } = this.state;
		const form = forms[activeForm];

		if (form && form.accountId === session.user.idAccount) return true;
		else if (form && form.accountId !== session.user.idAccount) return allowPartnerUpdateTemplatePdf;
		else return true;
	}
	getAllowPartnerDownloadTemplatePdf = () =>{
		const { forms, session, allowPartnerDownloadTemplatePdf } = this.props;
		if (!forms || forms.length === 0) return false;
		const { activeForm } = this.state;
		const form = forms[activeForm];

		if (form && form.accountId === session.user.idAccount) return true;
		else if (form && form.accountId !== session.user.idAccount) return allowPartnerDownloadTemplatePdf;
		else return true;
	}
	isPartnerAndHasPermission = () => {
		const { forms, session, allowPartnerToGenerateForms } = this.props;
		const { activeForm } = this.state;
		const form = forms[activeForm];

		if (!form) return false;

		const isSameAccount = form.accountId === session.user.idAccount;
		const isPartnerWithPermission = form.accountId !== session.user.idAccount && allowPartnerToGenerateForms;

		return isSameAccount || isPartnerWithPermission;
	};
	isPartnerAndHasNotPermission = () => {
		const { forms, session, allowPartnerToGenerateForms } = this.props;
		const { activeForm } = this.state;
		const form = forms[activeForm];

		return (
			form &&
			form.accountId !== session.user.idAccount &&
			!allowPartnerToGenerateForms
		);
	};
	generatePDF = () => {
		const { forms } = this.props;
		const { activeForm } = this.state;
		const form = forms[activeForm];
		this.generateCustomPDFFromHtml(form, null, null, true);
	};
	validateManagerGeneratePdf = () => {
		if (RoleUtils.isUserManager(this.props.session.user) &&
      this.props?.session?.accountPreferences?.allowManagerToGeneratePdf) return true;
		return false;
	}
	getDate = (question) => {
		if (question.date) {
			let timeZone = this.props.taskData.startLocation.timeZone;
			question.dateFormat.replace('dd', 'DD');
			return moment(question.date).tz(timeZone).format('DD/MM/YYYY hh:mm');
		}
		return '';
	};
	/*getFieldQuestion = (question) => {
		var text = '';
		switch (parseInt(question.type)) {
			case Types.MULTIPLE_CHOICE:
				let selected = [];
				question.options.some((opt) => {
					if (opt.checked === true) {
						selected.push(opt.name);
						if (question.singleAnswer === true) {
							return true;
						}
					}
				});
				text = selected.join(', ');
				break;
			case Types.TEXT_FIELD:
				text = question.text;
				break;
			case Types.NUMERIC_RATING:
				text = question.value;
				break;
			case Types.BINARY_RATING:
				if (question.iconType === 'FINGERS') {
					question.value === true ? (text = likeIcon) : (text = dislikeIcon);
				} else {
					question.value === true ? (text = happyIcon) : (text = sadIcon);
				}
				break;
			case Types.STARS_RATING:
				text = question.value;
				break;
			case Types.ELECTRONIC_SIGNATURE:
				text = question.file;
				break;
			case Types.FILES:
				if (question.enableMetadata) {
					let timeZone = 'x';
					if (question.metaData && question.metaData.timeZone) {
						timeZone = question.metaData.timeZone;
					}
					text = (
						<React.Fragment>
							<div className='row ml-1'>
                <OrientedImage style={{ maxWidth: '418px', maxHeight: '350px', transform: 'none' }} src={question.file} />
							</div>
							<div className='row  mt-2'>
								<div className='col-4 pl-0 d-flex justify-content-center' style={{ fontWeight: 'bold' }}>
									{this.props.lan.latitude}
								</div>
								<div className='col-4 d-flex justify-content-center' style={{ fontWeight: 'bold' }}>
									{this.props.lan.longitude}
								</div>
								<div className='col d-flex justify-content-center' style={{ fontWeight: 'bold' }}>
									{this.props.lan.date}
								</div>
							</div>
							<div className='row mb-3'>
								<div className='col-4 pl-0  d-flex justify-content-center'>
									{question.metaData ? question.metaData.latitude : this.props.lan.noData}
								</div>
								<div className='col-4  d-flex justify-content-center'>
									{question.metaData ? question.metaData.longitude : this.props.lan.noData}
								</div>
								<div className='col  d-flex justify-content-center'>
									{question.metaData
										? moment.tz(question.metaData.creationDate, timeZone).format('DD-MM-YYYY HH:mm')
										: this.props.lan.noData}
								</div>
							</div>
						</React.Fragment>
					);
				} else {
					text = <OrientedImage style={{ maxWidth: '418px', maxHeight: '350px' }} src={question.file} />
				}
				break;
			case Types.CODEBAR_IMG:
				text = question.file;
				break;
			case Types.CODEBAR_TEXT:
				text = question.value;
				break;
			case Types.DATE_HOUR:
				text = question.parsedDate ? question.parsedDate : this.getDate(question);
				if (text != null) {
					text = text.replace('January', this.props.lan.january);
					text = text.replace('February', this.props.lan.february);
					text = text.replace('March', this.props.lan.march);
					text = text.replace('April', this.props.lan.april);
					text = text.replace('May', this.props.lan.may);
					text = text.replace('June', this.props.lan.june);
					text = text.replace('July', this.props.lan.july);
					text = text.replace('August', this.props.lan.august);
					text = text.replace('September', this.props.lan.september);
					text = text.replace('October', this.props.lan.october);
					text = text.replace('November', this.props.lan.november);
					text = text.replace('December', this.props.lan.december);
				} else {
					text = '';
				}
				break;
			case Types.TEXT_FILE:
				if (question.file) {
					if (this.state.showFormFile[question.id]) {
						text = (
							<TextareaAutosize
								readOnly
								className={'task-details-input'}
								value={this.state.showFormFile[question.id]}
								style={{
									width: '100%',
									paddingTop: '5px',
									paddingLeft: '10px',
									paddingBottom: '5px',
									paddingRight: '10px',
								}}
							/>
						);
					} else {
						text = (
							<button className='Fielder-button-clear' onClick={() => this.getTextFile(question)}>
								{this.props.lan.viewFileContent}
							</button>
						);
					}
				} else {
					text = <button className='Fielder-button-clear-disabled'>{this.props.lan.noFileFound}</button>;
				}
				break;
			case Types.CATALOGUE:
				let columns = [
					{ id: 'id', padding: '' },
					{ id: 'option', padding: '' },
				];

				if (question.includeValue) {
					columns.push({
						id: 'value',
						name: this.props.lan.value,
						padding: '',
					});
				}

				if (question.includeComment) {
					columns.push({
						id: 'comment',
						name: this.props.lan.comment,
						padding: '',
					});
				}

				let rows = question.options
					.map((opt) => {
						if (opt.checked) {
							return {
								id: opt.id,
								option: opt.name,
								value: opt.value ? opt.value : '',
								comment: opt.comment ? opt.comment : '',
							};
						}
					})
					.filter((n) => n);

				return (
					<Grid container className='mt-4'>
						<Grid size={10} className='ml-auto mr-5'>
							<Grid container>
								<Grid size={3} style={{ wordWrap: 'break-word' }}>{question.title}</Grid>
								<Grid size={9} className='dashed-box-border p-3'>
									{rows && rows.length > 0 && (
										<MainTable dense disabled fullItemsHeight cols={columns} rows={rows} height={500} {...this.props} />
									)}
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				);
      case Types.INVENTORY:
        return (
          <Grid container className='mt-4'>
            <Grid size={10} className='ml-auto mr-5'>
              <Grid container>
                <Grid size={3} style={{ wordWrap: 'break-word' }}>{question.title}</Grid>
                <Grid size={9} className='dashed-box-border p-3'>
                  {question.inventoryId && (
                    <Grid container>
                      <Grid size={4}>{this.props.lan.id}:</Grid>
                      <Grid size={8}>{question.inventoryId}</Grid>
                    </Grid>
                  )}
                  {question.includeInventoryType && (
                    <Grid container className={question.inventoryId ? 'mt-2' : ''}>
                      <Grid size={4}>{this.props.lan.type}:</Grid>
                      <Grid size={8}>{question.inventoryType}</Grid>
                    </Grid>
                  )}
                  {question.includeName && (
                    <Grid container className={(question.inventoryId || question.includeInventoryType) ? 'mt-2' : ''}>
                      <Grid size={4}>{this.props.lan.name}:</Grid>
                      <Grid size={8}>{question.name}</Grid>
                    </Grid>
                  )}
                  {question.includeBrand && (
                    <Grid container className={(question.inventoryId ||
                        question.includeInventoryType || question.includeName) ? 'mt-2' : ''}>
                      <Grid size={4}>{this.props.lan.brand}:</Grid>
                      <Grid size={8}>{question.brand}</Grid>
                    </Grid>
                  )}
                  {question.includeModel && (
                    <Grid container
                      className={(question.inventoryId ||
                        question.includeInventoryType || question.includeName || question.includeBrand) ? 'mt-2' : ''}>
                      <Grid size={4}>{this.props.lan.model}:</Grid>
                      <Grid size={8}>{question.model}</Grid>
                    </Grid>
                  )}
                  {question.includeSerialNumber && (
                    <Grid container
                      className={(question.inventoryId || question.includeInventoryType ||
                        question.includeName || question.includeBrand || question.includeModel) ? 'mt-2' : ''}>
                      <Grid size={4}>{this.props.lan.serialNumber}:</Grid>
                      <Grid size={8}>{question.serialNumber}</Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      case Types.ASSET:
        return (
          <Grid container className='mt-4'>
            <Grid size={10} className='ml-auto mr-5'>
              <Grid container>
                <Grid size={3} style={{ wordWrap: 'break-word' }}>{question.title}</Grid>
                <Grid size={9} className='dashed-box-border p-3'>
                  {question.assetId && (
                    <Grid container>
                      <Grid size={4}>{this.props.lan.id}:</Grid>
                      <Grid size={8}>{question.assetId}</Grid>
                    </Grid>
                  )}
                  {question.includeAssetType && (
                    <Grid container className={question.assetId ? 'mt-2' : ''}>
                      <Grid size={4}>{this.props.lan.type}:</Grid>
                      <Grid size={8}>{question.assetType}</Grid>
                    </Grid>
                  )}
                  {question.includeName && (
                    <Grid container className={(question.assetId || question.includeAssetType) ? 'mt-2' : ''}>
                      <Grid size={4}>{this.props.lan.name}:</Grid>
                      <Grid size={8}>{question.name}</Grid>
                    </Grid>
                  )}
                  {question.includeBrand && (
                    <Grid container
                      className={(question.assetId ||
                        question.includeAssetType || question.includeName) ? 'mt-2' : ''}>
                      <Grid size={4}>{this.props.lan.brand}:</Grid>
                      <Grid size={8}>{question.brand}</Grid>
                    </Grid>
                  )}
                  {question.includeModel && (
                    <Grid container
                      className={(question.assetId ||
                        question.includeAssetType || question.includeName || question.includeBrand) ? 'mt-2' : ''}>
                      <Grid size={4}>{this.props.lan.model}:</Grid>
                      <Grid size={8}>{question.model}</Grid>
                    </Grid>
                  )}
                  {question.includeSerialNumber && (
                    <Grid container
                      className={(question.assetId || question.includeAssetType ||
                        question.includeName || question.includeBrand || question.includeModel) ? 'mt-2' : ''}>
                      <Grid size={4}>{this.props.lan.serialNumber}:</Grid>
                      <Grid size={8}>{question.serialNumber}</Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
			default:
				text = '';
				break;
		}

		// delete null spaces
		if (text == null) {
			text = '';
		}

		if (parseInt(question.type) === Types.ELECTRONIC_SIGNATURE || parseInt(question.type) === Types.CODEBAR_IMG) {
			return (
				<Grid container className='mt-4'>
					<Grid size={10} className='ml-auto mr-5'>
						<Grid container>
							<Grid size={3} style={{ wordWrap: 'break-word' }}>{question.title}</Grid>
							<Grid size={9}>
								<div className='dashed-box-border'>
									{text !== '' ? (
										<img
											src={text}
											className='mx-auto d-block my-4'
											style={{ maxWidth: '100%', maxHeight: '400px' }}
											alt=''
										/>
									) : (
										''
									)}
								</div>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			);
		} else if (parseInt(question.type) === Types.FILES) {
			return (
				<Grid container className='mt-4'>
					<Grid size={10} className='ml-auto mr-5'>
						<Grid container>
							<Grid size={3} style={{ height: '400px', wordWrap: 'break-word' }}>
								{question.title}
							</Grid>
							<Grid size={9} style={{ height: '400px' }}>
								<div className='task-details-input-photo' style={{ height: '400px' }}>
									{text !== '' ? text : ''}
								</div>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			);
		} else if (parseInt(question.type) === Types.STARS_RATING) {
			let stars = [];
			for (var i = 0; i < 5; i++) {
				if (i < text) {
					stars.push(
						<div className='ml-2'>
							{' '}
							<img src={yellowStarIcon} style={{ maxHeight: '25px' }} alt='' />{' '}
						</div>
					);
				} else {
					stars.push(
						<div className='ml-2'>
							{' '}
							<img src={greyStarIcon} style={{ maxHeight: '25px' }} alt='' />{' '}
						</div>
					);
				}
			}

			return (
				<Grid container className='mt-4'>
					<Grid size={10} className='ml-auto mr-5'>
						<Grid container>
							<Grid size={3} style={{wordWrap: 'break-word'}}>{question.title}</Grid>
							<Grid size={9}>
								<div
									className='task-details-input-photo row ml-1'
									style={{ maxWidth: '100%', paddingTop: '10px', paddingBottom: '10px' }}
								>
									{stars}
								</div>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			);
		} else if (parseInt(question.type) === Types.BINARY_RATING) {
			return (
				<Grid container className='mt-4'>
					<Grid size={10} className='ml-auto mr-5'>
						<Grid container>
							<Grid size={3} style={{wordWrap: 'break-word'}}>{question.title}</Grid>
							<Grid size={9}>
								<div
									className='task-details-input-photo row ml-1'
									style={{ maxWidth: '100%', paddingTop: '10px', paddingBottom: '10px' }}
								>
									<div className='ml-3'>
										<img src={text} style={{ maxHeight: '25px' }} alt='' />
									</div>
								</div>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			);
		} else if (parseInt(question.type) == Types.TEXT_FILE) {
			return (
				<Grid container className='mt-4'>
					<Grid size={10} className='ml-auto mr-5'>
						<Grid container>
							<Grid size={3} style={{wordWrap: 'break-word'}} >{question.title}</Grid>
							<Grid size={9}>
								<div className='ml-3'>{text}</div>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			);
		} else {
			return (
				<Grid container className='mt-4'>
					<Grid size={10} className='ml-auto mr-5'>
						<Grid container>
							<Grid size={3} style={{wordWrap: 'break-word'}} >{question.title}</Grid>
							<Grid size={9}>
								<TextareaAutosize
									readOnly
									className={'task-details-input'}
									value={text}
									style={{
										width: '100%',
										paddingTop: '5px',
										paddingLeft: '10px',
										paddingBottom: '5px',
										paddingRight: '10px',
									}}
								/>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			);
		}
	};*/
  renderQuestionField = (question) => {
    const timezone = this.props.taskData?.startLocation?.timeZone;
    return getTaskModulesFieldQuestion(
      question,
      this.state.showFormFile,
      timezone,
      this.props.lan,
      this.getTextFile,
      true
    );
  };
  getTextFile = async (question, isField = false) => {
    let getTextFromFile = () => {
      return new Promise((res, rej) => {
        let request = new XMLHttpRequest();
        request.open('GET', question.file, true);
        request.send();
        request.onreadystatechange = () => {
          if (request.readyState === 4 && request.status === '200') {
            let type = request.getResponseHeader('Content-Type');
            if (type.indexOf('text') !== 1) {
              res(request.response);
            }
          }
        };
      });
    };
    let text = await getTextFromFile();
    let state = this.state;
    state.showFormFile[question.id] = text;
    this.setState(state);
  };
	/*getTextFile = async (question) => {
		let getTextFromFile = () => {
			return new Promise((res, rej) => {
				let request = new XMLHttpRequest();
				request.open('GET', question.file, true);
				request.send();
				request.onreadystatechange = () => {
					if (request.readyState === 4 && request.status === '200') {
						let type = request.getResponseHeader('Content-Type');
						if (type.indexOf('text') !== 1) {
							res(request.response);
						}
					}
				};
			});
		};
		let text = await getTextFromFile();
		let state = this.state;
		state.showFormFile[question.id] = text;
		this.setState(state);
	};*/
	createFieldsForm = () => {
    const currentForm = this.state.forms[this.state.activeForm];
    const fields = currentForm?.fields || [];
    const formsFields = fields.map((field, i) => (
      <Box key={`Forms-row-${i}`} id={`Forms-row-${i}`} sx={{ mt: 1 }}>
        {this.renderQuestionField(field.question)}
      </Box>
    ));
    return (
      <Grid container>
        <Grid size={12}>
          <Typography variant="h6">{this.props.lan.questions}</Typography>
        </Grid>
        <Grid size={12}>{formsFields}</Grid>
      </Grid>
    );
    /*let fields = this.state.forms[this.state.activeForm].fields;
		var formsFields = [];
		fields?.forEach((field, i) => {
			formsFields.push(
				<Box id={`Forms-row-${i}`} sx={{ mt: 1 }}>
					{this.getFieldQuestions(field.question)}
				</Box>
			);
		});
		return (
			<Grid container>
        <Grid size={12}>
          <Typography variant={'h6'}>{this.props.lan.questions}</Typography>
        </Grid>
        <Grid size={12}>{formsFields}</Grid>
			</Grid>
		);*/
	};
	hasFinishForms = () => {
		if (this.state.forms && this.state.forms.length >0) {
			for (let i = 0; i < this.state.forms.length; i++) {
				if(this.state.forms[i].status === 'FINISHED' || this.props.allowGenerateFormsIfTaskStatusWasModify)
				return true
			}
		}
		return false;
	}
	generateModulesZip = async () => {
		let zip = new JSZip();

		let total = this.state.forms.length;
		total += this.state.inventory ? this.state.inventory.length : 0;
		total += this.state.assets ? this.state.assets.length : 0;

		let progressFactor = Math.round(100 / total);
		let progressCount = 0;

		if (this.state.forms && this.state.forms.length >0) {
			for (let i = 0; i < this.state.forms.length; i++) {
				if (this.state.forms[i].status == 'FINISHED' || this.props.allowGenerateFormsIfTaskStatusWasModify ) {
					progressCount++;
					let formFile = await this.generateCustomPDFFromHtml(this.state.forms[i], null, null, false);
					await this.setFileToZip(formFile, this.props.lan.form + '-' + this.state.forms[i].name, zip);


					this.props.dispatch(loadingStart({
						name: this.props.pageName,
						config: {
							icon: LoadingConst.EXPORT,
							text: this.props.lan.exportingModules,
							progress: progressFactor * progressCount
						}
					}));
				}
			}
		}

		if (this.state.assets) {
			for (let i = 0; i < this.state.assets.length; i++) {
				progressCount++;
				let assetFile = await this.generateCustomPDFFromHtml(null, this.state.assets[i], null, false);
				await this.setFileToZip(assetFile, this.props.lan.asset + '-' + this.state.assets[i].name, zip);

				this.props.dispatch(loadingStart({
					name: this.props.pageName,
					config: {
						icon: LoadingConst.EXPORT,
						text: this.props.lan.exportingModules,
						progress: progressFactor * progressCount
					}
				}));
			}
		}

		if (this.state.inventory) {
			for (let i = 0; i < this.state.inventory.length; i++) {
				progressCount++;
				let inventoryFile = await this.generateCustomPDFFromHtml(null, null, this.state.inventory[i], false);
				await this.setFileToZip(inventoryFile, this.props.lan.inventory + '-' + this.state.inventory[i].name, zip);

				this.props.dispatch(loadingStart({
					name: this.props.pageName,
					config: {
						icon: LoadingConst.EXPORT,
						text: this.props.lan.exportingModules,
						progress: progressFactor * progressCount
					}
				}));
			}
		}

		zip.generateAsync({ type: 'blob' }).then((content) => {
			saveAs(content, this.props.taskData.idFielder + '-' + this.props.lan.modulesZipSuffix);
			this.props.dispatch(loadingStop({ name: this.props.pageName }));
		});
	};
	setFileToZip = async (fileLink, fileName, zip) => {
		await new Promise((resolve, reject) => {
			const fileLinkAux = fileLink.split(process.env.FIELDER_CONTENT_LINK);
			const archiveUrl = `https://${process.env.AWS_BUCKET}.s3.amazonaws.com${fileLinkAux[1]}`;

			JSZipUtils.getBinaryContent(archiveUrl, (err, data) => {
				let newFileName = this.props.taskData.idFielder + '-' + fileName + '.pdf';

				// Add File To Zip
				zip.file(newFileName, data, { binary: true });
				resolve();
			});
		});
	};
	redirectToMarketPlace = () => {
		this.props.navigate(ENDPOINTS.marketplace);
	};
	generateXlsx = async (generatePdfFromXlsx) => {
		this.props.dispatch(loadingStart({ name: this.props.pageName }));
		let form = this.state.forms[this.state.activeForm];
		form.formIndex = (this.state.activeForm + 1);
		console.log("this.state.activeForm");
		console.log(this.state.activeForm);

		const body = {
			form: form,
			idTask: this.props.taskData.idFielder,
			task: this.props.taskData,
			agent: this.props.taskAgent,
			idCompany: this.props.taskData.branch?.idCompany
		};

		const onSuccess = (response) => {
			if (generatePdfFromXlsx) {
				let state = this.state;
				state.show.generatePdfFromXlsx = true;
				state.urlGeneratePdfFromXlsx = response.link;
				this.setState(state);
				this.props.dispatch(loadingStop({ name: this.props.pageName }));
			} else {
				this.props.dispatch(loadingStop({ name: this.props.pageName }));
				window.open(response.link);
			}
		}

		const onError = (error) => {
			this.props.dispatch(loadingStop({ name: this.props.pageName }));
		}

		getXLSXOrHTMLFromFormRequest(body, onSuccess, onError, null);

	};
	uploadTaskFormPdf = async (form, formFileUrl, conversionCost) => {
		const body = {
			conversionCost: conversionCost,
			serviceFilePdf: {
				idService: this.props.taskData.idFielder,
				idTaskForm: form.idTaskForm,
				documentName: `${this.props.taskData.idFielder}-${form.name}.pdf`,
				fileUrl: formFileUrl,
			}
		};

		await new Promise((resolve, reject) => {
			this.props.dispatch(loadingStart({ name: this.props.pageName }));

			const onSuccess = (response) => {
				this.props.reloadData();
				resolve(response);
			}

			const onError = (error) => {
				reject();
			}

			uploadTaskFormPdfRequest(body, onSuccess, onError, null)
		});

		let state = this.state;
		state.messageApproved = this.props.lan.pdfAprovedMessage;
		state.iconMessage = SuccessIcon;
		state.show.generatePdfFromXlsx = false;
		state.showMessageSuccessAprove = true;
		state.view.forms = false;
		this.setState(state);

		this.props.dispatch(loadingStop({ name: this.props.pageName }));
	};
	approveDocument = async (link) => {
		if (link != null && link !== '') {
			this.props.dispatch(loadingStart({ name: this.props.pageName }));
			const activeForm = this.state.forms[this.state.activeForm];
			let convertApi = ConvertApi.auth({ secret: PDF_SECRECT_KEY });
			let params = convertApi.createParams();
			params.add('file', new URL(link));
			let result = await convertApi.convert('xlsx', 'pdf', params);
			if (result && result.files && result.files[0].Url) {
				let url = result.files[0].Url;
				let conversionCost = result.dto.ConversionCost;
				let bitesUrl = await new Promise((resolve) => {
					this.getBase64FromUrl(url).then((res) => resolve(res));
				});
				this.dataURLToFile(bitesUrl).then(async (file) => {
					if (file instanceof Error) {
						this.showErrorMessageApprovedLink();
						this.props.dispatch(loadingStop({ name: this.props.pageName }));
					} else {
						const formFileUrl = await this.uploadToS3(
              file, activeForm, this.props.idAccountTask, this.props.session.user.idUser);
						if (formFileUrl != null) {
							await this.uploadTaskFormPdf(activeForm, formFileUrl, conversionCost);
						}else {
							this.showErrorMessageApprovedLink();
							this.props.dispatch(loadingStop({ name: this.props.pageName }));
						}	
					}
				});
			} else{
				this.showErrorMessageApprovedLink();
				this.props.dispatch(loadingStop({ name: this.props.pageName }));
			}
		} else {
			this.showErrorMessageApprovedLink();
		}
	};
	showErrorMessageApprovedLink = () => {
		let state = this.state;
		state.messageApproved = this.props.lan.pdfApprovedMessageError;
		state.iconMessage = ErrorIcon;
		state.show.generatePdfFromXlsx = false;
		state.showMessageSuccessAprove = true;
		state.view.forms = false;
		this.setState(state);
	}
	getBase64FromUrl = async (url) => {
		const data = await fetch(url);
		const blob = await data.blob();
		return new Promise((resolve) => {
			const reader = new FileReader();
			reader.readAsDataURL(blob);
			reader.onloadend = () => {
				const base64data = reader.result;
				resolve(base64data);
			};
		});
	};
	dataURLToFile = (base64) => {
		return fetch(base64)
			.then((res) => res.arrayBuffer())
			.then((buf) => new File([buf], 'filename', { type: 'application/pdf' }));
	};
	uploadToS3 = (file, currentForm, accountId, idUser) => {
		const bucket = `${BUCKET_NAME_KEY}/${accountId}/${this.props.taskData.idFielder}`;
		const key = `${currentForm.id}-form-pdf`;
		return presignedUrlForUpload(bucket, key, file, { contentType: file.type, acl: ACL }, idUser);
	};
	uploadToS3WithDate = (file, currentForm, accountId, date ) => {
		const bucket = `${BUCKET_NAME_KEY}/${accountId}/${this.props.taskData.idFielder}`;
		const key = `${currentForm.id}-${date}-form-pdf`;
		return presignedUrlForUpload(bucket, key, file, { contentType: file.type, acl: ACL }, idUser);
	};
	closeErrorMessageAprove = () => {
		let state = this.state;
		state.showMessageSuccessAprove = false;
		this.setState(state);
	};
	updateFileHandler = (event, idAccount, idFile, fileUrl) => {
		const file = event.target.files[0];
		var auxUrlFileKey = fileUrl.split(BUCKET_NAME_KEY);
		var urlFileKey = BUCKET_NAME_KEY + auxUrlFileKey[1];

		this.setState({
			fileUpdate: file,
			fileNameUpdate: file.name,
			idAccountFileUpdate: idAccount,
			originalIdFile: idFile,
			originalFileKey: urlFileKey,
			showUpdateMessage: true,
		});
	};
	handleCloseUpdate = () => {
		this.setState({
			showUpdateMessage: false,
			fileUpdate: null,
			fileNameUpdate: null,
			idAccountFileUpdate: null,
			originalIdFile: null,
			originalFileKey: null,
		});
	};
	updateFileConfirm = async () => {
		try {
		this.props.dispatch(loadingStart({ name: this.props.pageName }));
		const activeForm = this.state.forms[this.state.activeForm];
		const formFileUrl = await this.uploadToS3WithDate(this.state.fileUpdate, activeForm, this.state.idAccountFileUpdate, new Date().getTime());
			
		if (formFileUrl) {
			const body = {
				originalFileKey: this.state.originalFileKey,
				serviceFilePdf: {
					idFilePdf: this.state.originalIdFile,
					documentName: this.state.fileNameUpdate,
					idService: this.props.taskData.idFielder,
					fileUrl: formFileUrl,
					idAccount: this.props.session.user.idAccount,
					idUser: this.props.session.user.idUser,
				}
			};

			await new Promise((resolve, reject) => {

				const onSuccess = (response) => {
					this.props.reloadData();
					this.props.dispatch(loadingStop({ name: this.props.pageName }));
					resolve(response);
					this.setState({ showUpdateMessage: false });
				}

				const onError = (error) => {
					console.log(error);
					reject();
					this.props.dispatch(loadingStop({ name: this.props.pageName }));
				}

				updateTaskFormPdfRequest(body, onSuccess, onError, null)

			});
			let state = this.state;
			state.view.forms = false;
			this.setState(state);
		}

			this.props.dispatch(loadingStop({ name: this.props.pageName }));
			
		} catch (error) {
			console.log(error)	
		}
	};
	generateCustomPDFFromHtml = async (form, asset, inventory, openAuto) => {
		// Only have implemented pdf for html, therefore all
		// pdf's will generate with html type
		let loadingConfig = null
		let link = '';

		let body = {
			idTask: this.props.taskData.idFielder,
			task: this.props.taskData,
			agent: {
				name: this.props.taskAgent.name,
			},
		};

		if (!this.state.formsFunctionalities.html) {
			body.lan = this.props.lan._language;
		}


		if (form) {
			body.form = form;

			link = await new Promise((resolve, reject) => {

				const onSuccess = (res) => {

					try {
						let bodyHtml = {};
						bodyHtml.idTask = this.props.taskData.idFielder;
						bodyHtml.htmlUrlFile = res.link;
						bodyHtml.footerHtml = res.footer_link;
						bodyHtml.filename = this.props.taskData.idFielder+"-"+ new Date().getTime() + '-pdf';
						bodyHtml.idCompany = this.props.taskData.branch?.idCompany;
					


						const onSuccessHtml = (res) => {
							resolve(res.pdf);
						}
						const onErrorHtml = (error) => {
							reject();
						}

						getPdfFromHtmlRequest(bodyHtml, onSuccessHtml, onErrorHtml, loadingConfig);
					} catch(error) { 
						console.log(error)
					}	
				}

				const onError = (error) => {
					console.log(error)
					reject();
				}
				if (openAuto) {
					loadingConfig = { dispatch: this.props.dispatch }
				}

				getFormHTMLRequest(body, onSuccess, onError, loadingConfig);

			}).catch(() => {
				return;
			});

		} else if (asset) {
			let bodyAsset = JSON.parse(JSON.stringify(asset));
			bodyAsset.logs = [];
			bodyAsset.category = asset.category?.name;
			body.asset = bodyAsset;

			link = await new Promise((resolve, reject) => {

				const onSuccess = (res) => {
					let bodyHtml = {};
					bodyHtml.idTask = this.props.taskData.idFielder;
					bodyHtml.htmlUrlFile = res.link;
					bodyHtml.footerHtml = res.footer_link;
					bodyHtml.filename = this.props.taskData.idFielder + '-pdf';

					const onSuccessHtml = (res) => {
						resolve(res.pdf);
					}
					const onErrorHtml = (error) => {
						console.log(error)
						reject();
					}

					getPdfFromHtmlRequest(bodyHtml, onSuccessHtml, onErrorHtml, loadingConfig);
				}

				const onError = (error) => {
					reject();
				}
				if (openAuto) {
					loadingConfig = { dispatch: this.props.dispatch }
				}

				getAssetHTMLRequest(body, onSuccess, onError, loadingConfig);

			}).catch(() => {
				return;
			});
		} else if (inventory) {
			let bodyInventory = JSON.parse(JSON.stringify(inventory));
			bodyInventory.logs = [];
			bodyInventory.category = inventory.category.name;
			body.inventory = bodyInventory;

			link = await new Promise((resolve, reject) => {

				const onSuccess = (res) => {
					let bodyHtml = {};
					bodyHtml.idTask = this.props.taskData.idFielder;
					bodyHtml.htmlUrlFile = res.link;
					bodyHtml.footerHtml = res.footer_link;
					bodyHtml.filename = this.props.taskData.idFielder + '-pdf';

					const onSuccessHtml = (response) => {
						resolve(response.pdf);
					}
					const onErrorHtml = (error) => {
						console.log(error)
						reject();
					}

					getPdfFromHtmlRequest(bodyHtml, onSuccessHtml, onErrorHtml, loadingConfig);
				}

				const onError = (error) => {
					console.log(error)
					reject();
				}
				if (openAuto) {
					loadingConfig = { dispatch: this.props.dispatch }
				}

				getInventoryHTMLRequest(body, onSuccess, onError, loadingConfig);

			}).catch(() => {
				return;
			});

		} else {
			return;
		}


		if (openAuto) {
			window.open(link);
		} else {
			return link;
		}
	};
	downloadZipFile = (zip) => {
		let name = this.props.taskData.idFielder + '-';

		if (this.state.view.assets) {
			name = name + this.props.lan.asset;
		} else if (this.state.view.forms) {
			name = name + this.props.lan.forms;
		} else {
			name = name + this.props.lan.inventory;
		}

		zip.generateAsync({ type: 'blob' }).then((content) => {
			saveAs(content, name + '.zip');
			this.props.dispatch(loadingStop({ name: this.props.pageName }));
		});
	};
	getImagesFromGroup = async (images, index, zip) => {
		if (index < images.length) {
			const image = images[index];

			if (image) {
				let imageLink = image;
				let bucket = process.env.AWS_BUCKET;
				let link_split = image.split('com/');
				let key = link_split[1];

				if (key.includes(process.env.FIELDER_CONTENT_LINK)) {
					const fileLinkAux = key.split(process.env.FIELDER_CONTENT_LINK);
					imageLink = `https://${process.env.AWS_BUCKET}.s3.amazonaws.com${fileLinkAux[1]}`;
				} else if (!key.includes(bucket)) {
					imageLink = `https://${process.env.AWS_BUCKET}.s3.amazonaws.com/${key}`;
				} else {
					let auxKey = key.split(process.env.AWS_BUCKET);
					imageLink = `https://${process.env.AWS_BUCKET}.s3.amazonaws.com${auxKey[1]}`;
				}

				await new Promise((resolve, reject) => {
					JSZipUtils.getBinaryContent(imageLink, (err, data) => {
						zip.file(this.getImageName(image) + '.jpeg', data, { binary: true });
						resolve();
					});
				});

				this.getImagesFromGroup(images, index + 1, zip);
			} else {
				this.downloadZipFile(zip);
			}
		} else {
			this.downloadZipFile(zip);
		}
	};
	getImageName = (url) => {
		let separated = url.split('/');
		let imageName = '';
		const lastIndex = separated.length - 1;

		if (lastIndex > 0) {
			try {
				imageName = separated[lastIndex];
			} catch (e) {}
		}
		return imageName;
	};
	handlerDownloadImg = () => {
		this.props.dispatch(loadingStart({
			name: this.props.pageName,
			config: {
				icon: LoadingConst.EXPORT,
				text: this.props.lan.exportMessage
			},
		}));
		this.getImagesFromGroup(this.state.formImages, 0, new JSZip());
	};
	changeActiveForm = (i) => {
		let questions = this.state.forms[i].fields;
		let formImages = [];
		let formHasImages = false;

		questions.forEach((question) => {
			if (question.question.file != null && question.question.type !== Types.TEXT_FILE  && question.question.type !== Types.ELECTRONIC_SIGNATURE ) {
				formImages.push(question.question.file);
			}
		});

		if (formImages.length > 0) {
			formHasImages = true;
		} 

		this.checkCustomTemplate(this.state.forms[i]);
		this.checkPdfUpload(this.state.forms[i]);

		this.setState({
			activeForm: i,
			formHasImages: formHasImages,
			formImages: formImages,
		});
	};
	changeActiveAsset = (i) => {
		let questions = this.state.assets[i].questions;
		let assetImages = [];
		let assetHasImages = false;

		if(questions != null && questions.length > 0) {
			questions.forEach((question) => {
				if (question.file != null) {
					assetImages.push(question.file);
				}
			});
		}

		if (assetImages.length > 0) {
			assetHasImages = true;
		} else {
			assetHasImages = false;
		}

		this.setState({
			activeAsset: i,
			assetHasImages: assetHasImages,
			assetImages: assetImages,
		});
	};
	changeActiveInventory = (i) => {
		let questions = this.state.inventory[i].questions;
		let inventoryImages = [];
		let inventoryHasImages = false;

		questions.forEach((question) => {
			if (question.file != null) {
				inventoryImages.push(question.file);
			}
		});

		if (inventoryImages.length > 0) {
			inventoryHasImages = true;
		} else {
			inventoryHasImages = false;
		}

		this.setState({
			activeInventory: i,
			inventoryHasImages: inventoryHasImages,
			inventoryImages: inventoryImages,
		});
	};
	editFormVisibility = (value) => {
		let state = this.state;
		state.show.editForm = value;
		this.setState(state);
	};
	editPdfFromXlsxVisibility = () => {
		let state = this.state;
		state.show.generatePdfFromXlsx = false;
		//state.showMessageCancelAprove = true;
		this.setState(state);
	};
	reactivateFormPopup = (val) => {
		let state = this.state;
		state.show.reactivateForm = val;
		this.setState(state);
	};
	reactivateForm = (idTaskForm) => {
		const body = {
			idTask: this.props.taskData.idFielder,
			idTaskForm: idTaskForm,
		}

		const onSuccess = (response) => {
			this.reactivateFormPopup(null);
			this.props.reloadData();
		}

		const onError = (error) => {
			console.log(error)
		}

		const loadingConfig = { dispatch: this.props.dispatch }
		reactivateFormRequest(body, onSuccess, onError, loadingConfig)

	};
	removeFormTask = (index) => {
		this.removeTaskFormPopup(null);
		this.props.removeTaskForm(index);
	};
	removeTaskFormPopup = (val) => {
		let state = this.state;
		state.show.removeTaskForm = val;
		this.setState(state);
	};
	validateManagerApproveForm = () => {
		if (RoleUtils.isUserManager(this.props.session.user) && this.state.allowManagerToApproveForms && this.state.allowManagerToEditFormTaskDetail )  {
			return true;
		}

		return false;
	}
	/*FormHeader = () => {
		let clientType = this.props.taskData.client.clientType;
		let branchClientName = this.props.taskData.client.name;
		if (this.props.taskData.client.lastName != null) branchClientName += ' ' + this.props.taskData.client.lastName;
		return (
			<div>
				<Grid container className='mx-auto'>
					<Grid size={10} className='ml-auto mr-5'>
						<Grid container>
							<Grid size={6}>
								<Grid container>
									<Grid size={4}> {this.props.lan.customId}</Grid>
									<Grid size={8}>
										<input
											type='text'
											disabled
											className={'task-details-input'}
											defaultValue={this.props.taskData.number}
											style={{ width: '100%', paddingLeft: '10px', paddingRight: '10px' }}
										/>
									</Grid>
								</Grid>
							</Grid>
							<Grid size={6}>
								<Grid container>
									<Grid size={4}>{this.props.lan.idFielder}</Grid>
									<Grid size={8}>
										<input
											type='text'
											disabled
											className={'task-details-input'}
											defaultValue={this.props.taskData.idFielder}
											style={{ width: '100%', paddingLeft: '10px', paddingRight: '10px' }}
										/>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<Grid container className='mt-4'>
					<Grid size={10} className='ml-auto mr-5'>
						<Grid container>
							<Grid size={3}>{this.props.lan.formClientNameLabel[clientType]}</Grid>
							<Grid size={9}>
								<input
									type='text'
									disabled
									className={'task-details-input'}
									defaultValue={branchClientName}
									style={{ width: '100%', paddingLeft: '10px', paddingRight: '10px' }}
								/>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<Grid container className='mt-4'>
					<Grid size={10} className='ml-auto mr-5'>
						<Grid container>
							<Grid size={3}>{this.props.lan.formIdCustomLabel[clientType]}</Grid>
							<Grid size={9}>
								<input
									type='text'
									disabled
									className={'task-details-input'}
									defaultValue={this.props.taskData.client.idCustom}
									style={{ width: '100%', paddingLeft: '10px', paddingRight: '10px' }}
								/>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<Grid container className='mt-4'>
					<Grid size={10} className='ml-auto mr-5'>
						<Grid container>
							<Grid size={3}>{this.props.lan.agentName}</Grid>
							<Grid size={9}>
								<input
									type='text'
									disabled
									className={'task-details-input'}
									defaultValue={this.props.taskAgent.name}
									style={{ width: '100%', paddingLeft: '10px', paddingRight: '10px' }}
								/>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<Grid container className='mt-4'>
					<Grid size={10} className='ml-auto mr-5'>
						<Grid container>
							<Grid size={3}>{this.props.lan.address}</Grid>
							<Grid size={9}>
								<TextareaAutosize
									readOnly
									className={'task-details-input'}
									defaultValue={this.props.taskData.address}
									style={{
										width: '100%',
										paddingTop: '5px',
										paddingLeft: '10px',
										paddingBottom: '5px',
										paddingRight: '10px',
									}}
								/>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</div>
		);
	};*/
  FormHeader = () => {
    const { taskData, taskAgent, lan } = this.props;
    const clientType = taskData.client.clientType;
    let branchClientName = taskData.client.name;
    if (taskData.client.lastName != null) {
      branchClientName += ' ' + taskData.client.lastName;
    }
    const readOnlyFieldSx = (theme) => ({
      '& .MuiOutlinedInput-root': {
        backgroundColor: theme.palette.action.hover,
        paddingY: 0.5,
        paddingX: 1.25,
      },
      '& .MuiOutlinedInput-input': {
        fontSize: 13,
      },
    });
    return (
      <Grid container justifyContent="center" sx={{ p: 0.5, ml: 1, mr: 1 }} spacing={1}>
        {/* Custom ID + Fielder ID */}
        <Grid size={12}>
          <Grid container spacing={1}>
            {/* Custom Id */}
            <Grid size={6}>
              <Grid container spacing={1} alignItems="center">
                <Grid size={4}>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {lan.customId}
                  </Typography>
                </Grid>
                <Grid size={8}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    value={taskData.number}
                    slotProps={{ input: { readOnly: true } }}
                    disabled
                    sx={(theme) => readOnlyFieldSx(theme)}
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* Fielder Id */}
            <Grid size={6}>
              <Grid container spacing={1} alignItems="center">
                <Grid size={4}>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {lan.idFielder}
                  </Typography>
                </Grid>
                <Grid size={8}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    value={taskData.idFielder}
                    slotProps={{ input: { readOnly: true } }}
                    disabled
                    sx={(theme) => readOnlyFieldSx(theme)}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* Client / Branch Name */}
        <Grid size={12}>
          <Grid container spacing={1} alignItems="center">
            <Grid size={3}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {lan.formClientNameLabel[clientType]}
              </Typography>
            </Grid>
            <Grid size={9}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                value={branchClientName}
                slotProps={{ input: { readOnly: true } }}
                disabled
                sx={(theme) => readOnlyFieldSx(theme)}
              />
            </Grid>
          </Grid>
        </Grid>
        {/* Client / Branch Id */}
        <Grid size={12}>
          <Grid container spacing={1} alignItems="center">
            <Grid size={3}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {lan.formIdCustomLabel[clientType]}
              </Typography>
            </Grid>
            <Grid size={9}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                value={taskData.client.idCustom}
                slotProps={{ input: { readOnly: true } }}
                disabled
                sx={(theme) => readOnlyFieldSx(theme)}
              />
            </Grid>
          </Grid>
        </Grid>
        {/* Agent Name */}
        <Grid size={12}>
          <Grid container spacing={1} alignItems="center">
            <Grid size={3}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {lan.agentName}
              </Typography>
            </Grid>
            <Grid size={9}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                value={taskAgent.name}
                slotProps={{ input: { readOnly: true } }}
                disabled
                sx={(theme) => readOnlyFieldSx(theme)}
              />
            </Grid>
          </Grid>
        </Grid>
        {/* Address (multiline) */}
        <Grid size={12}>
          <Grid container spacing={1} alignItems="flex-start">
            <Grid size={3}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {lan.address}
              </Typography>
            </Grid>
            <Grid size={9}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                value={taskData.address}
                slotProps={{ input: { readOnly: true } }}
                disabled
                multiline
                minRows={2}
                sx={(theme) => ({
                  ...readOnlyFieldSx(theme),
                  '& .MuiOutlinedInput-root': {
                    ...readOnlyFieldSx(theme)['& .MuiOutlinedInput-root'],
                    alignItems: 'flex-start',
                  },
                })}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };
  /*FormTitles = () => {
    let titleClass = '';
    return (
      <div className='nav flex-column nav-pills mt-4 ml-3' role='tablist' aria-orientation='vertical'>
        {this.state.forms.map((form, i) => {
          titleClass = '';
          if (this.state.activeForm === i) {
            titleClass = titleClass + ' active form-active';
          } else {
            titleClass = titleClass + ' nav-link form-inactive ';
          }
          let statusIcon = null;
          if (form.status === 'IN_REVIEW' && form.reviewable) {
            statusIcon = (
              <Tooltip title={this.props.lan.inReviewForm} arrow>
                <Icon style={{ color: '#fbc02d' }}>warning_rounded</Icon>
              </Tooltip>
            );
          } else if (form.status === 'NOT_APPROVED' && form.reviewable) {
            statusIcon = (
              <Tooltip title={this.props.lan.hasNotApprovedForm} arrow>
                <Icon style={{ color: '#F50057' }}>error_rounded</Icon>
              </Tooltip>
            );
          }
          return (
            <div
              data-toggle='pill'
              role='tab'
              aria-controls='v-pills-home'
              key={'forms-' + i}
              aria-selected={(this.state.activeForm === i) + ''}
              className={'nav-link ' + titleClass}
              onClick={() => this.changeActiveForm(i)}
            >
              <Grid container>
                <Grid size={1}>
                  {form.status !== 'FINISHED' &&
                    form.accountId === this.props.session.account.id &&
                    !this.props.client &&
                    this.state.isAllowedToDeleteTaskForm && (
                      <button
                        className='taskModule-deleteForm'
                        onClick={() => this.removeTaskFormPopup(form.idTaskForm)}
                      >
                        &times;
                      </button>
                    )}
                </Grid>
                <Grid size={'grow'}>{(i+1) + ".- " + form.name}</Grid>
                {form.accountId !== this.props.session.account.id && (
                  <Grid size={1}>
                    <img src={PartnerIcon} alt='' />
                  </Grid>
                )}
                  <Grid size={1} className='pr-1'>
                    {statusIcon &&
                      (RoleUtils.isUserAdministrator(this.props.session.user) ||
                        RoleUtils.isUserSuperAdministrator(this.props.session.user) || this.validateManagerApproveForm()) &&
                      statusIcon}
                  </Grid>
                { form.status !== 'FINISHED' && (
                  <div>
                  {((form.accountId === this.props.session.account.id) ||
                    (form.accountId !== this.props.session.account.id && form.partnersEditable)) && (
                    <Grid size={1} className='pl-0'>
                      {(((RoleUtils.isUserAdministrator(this.props.session.user) ||
                        RoleUtils.isUserSuperAdministrator(this.props.session.user) ||
                        this.props.client) && this.state.isAllowedToEditTask) ||
                          (RoleUtils.isUserManager(this.props.session.user) && this.state.allowManagerToEditFormTaskDetail)) && (
                          <Tooltip title={this.props.lan.edit} arrow>
                            <IconButton className='p-0' onClick={() => this.editFormVisibility(true)}>
                              <Icon color='disabled'>edit</Icon>
                            </IconButton>
                          </Tooltip>
                        )}
                    </Grid>
                  )}
                  </div>
                )}
              </Grid>
            </div>
          );
        })}
      </div>
    );
  };*/
  FormTitles = () => {
    const { forms } = this.state;
    const { session, client, lan } = this.props;

    if (!forms || !forms.length) return null;

    return (
      <>
        {forms.map((form, i) => {
          const isActive = this.state.activeForm === i;

          let statusIcon = null;
          if (form.status === 'IN_REVIEW' && form.reviewable) {
            statusIcon = (
              <Tooltip title={lan.inReviewForm} arrow>
                <Icon color="warning">warning_rounded</Icon>
              </Tooltip>
            );
          } else if (form.status === 'NOT_APPROVED' && form.reviewable) {
            statusIcon = (
              <Tooltip title={lan.hasNotApprovedForm} arrow>
                <Icon color="error">error_rounded</Icon>
              </Tooltip>
            );
          }

          const canDeleteForm =
            form.status !== 'FINISHED' &&
            form.accountId === session.account.id &&
            !client &&
            this.state.isAllowedToDeleteTaskForm;

          const canEditForm =
            form.status !== 'FINISHED' &&
            ((form.accountId === session.account.id) ||
              (form.accountId !== session.account.id && form.partnersEditable));

          const showEditButton =
            canEditForm &&
            (((RoleUtils.isUserAdministrator(session.user) ||
                  RoleUtils.isUserSuperAdministrator(session.user) ||
                  client) &&
                this.state.isAllowedToEditTask) ||
              (RoleUtils.isUserManager(session.user) &&
                this.state.allowManagerToEditFormTaskDetail));

          return (
            <Box
              id={`forms-${i}`}
              component="button"
              type="button"
              role="tab"
              aria-controls="v-pills-home"
              aria-selected={isActive ? 'true' : 'false'}
              onClick={() => this.changeActiveForm(i)}
              sx={(theme) => ({
                border: 'none',
                padding: 0,
                margin: 0,
                width: '100%',
                cursor: 'pointer',
                textAlign: 'left',
                backgroundColor: 'transparent',
                mb: 0.5,
                '&:focus-visible': {
                  outline: `2px solid ${theme.palette.primary.main}`,
                  outlineOffset: 2,
                },

                '& > .titleContainer': {
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: 1,
                  padding: theme.spacing(1, 1.5),
                  border: `1px solid ${
                    isActive ? theme.palette.divider : 'transparent'
                  }`,
                  backgroundColor: isActive
                    ? theme.palette.mode === 'dark'
                      ? theme.palette.action.selected
                      : theme.palette.action.hover
                    : theme.palette.background.paper,
                  color: theme.palette.text.primary,
                  transition: theme.transitions.create(
                    ['background-color', 'border-color'],
                    { duration: theme.transitions.duration.shortest }
                  ),
                  '&:hover': {
                    backgroundColor: isActive
                      ? theme.palette.mode === 'dark'
                        ? theme.palette.action.selected
                        : theme.palette.action.hover
                      : theme.palette.action.hover,
                  },
                },
              })}
            >
              <Box className="titleContainer">
                <Grid container alignItems="center" wrap="nowrap" columnGap={1}>
                  {/* Delete Form */}
                  {canDeleteForm && (
                    <Grid size="auto">
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.removeTaskFormPopup(form.idTaskForm);
                        }}
                        sx={{ p: 0.25, '&:hover': { backgroundColor: 'transparent' } }}
                      >
                        <Icon fontSize="small">close</Icon>
                      </IconButton>
                    </Grid>
                  )}

                  {/* Title */}
                  <Grid size="grow">
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: isActive ? 600 : 400 }}
                    >
                      {`${i + 1}.- ${form.name}`}
                    </Typography>
                  </Grid>

                  {/* Partner Icon */}
                  {form.accountId !== session.account.id && (
                    <Grid size="auto">
                      <Box
                        component="img"
                        src={PartnerIcon}
                        sx={{ width: 20, height: 20 }}
                      />
                    </Grid>
                  )}

                  {/* Status Icon */}
                  {statusIcon &&
                    (RoleUtils.isUserAdministrator(session.user) ||
                      RoleUtils.isUserSuperAdministrator(session.user) ||
                      this.validateManagerApproveForm()) && (
                      <Grid size="auto">{statusIcon}</Grid>
                    )}

                  {/* Edit Button */}
                  {showEditButton && (
                    <Grid size="auto">
                      <Tooltip title={lan.edit} arrow>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.editFormVisibility(true);
                          }}
                          sx={{ p: 0.25, '&:hover': { backgroundColor: 'transparent' } }}
                        >
                          <Icon fontSize="small">edit</Icon>
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Box>
          );
        })}
      </>
    );
  };
  viewForm = () => {
		let form = this.props.forms[this.state.activeForm];
		this.props.navigate(`${ENDPOINTS.forms}?id=${form.id}`);
	};
	setViewImport = (value) => {
		if (!value) {
			document.getElementById('task-detail-modal').style.opacity = '1';
		} else { 
			document.getElementById('task-detail-modal').style.opacity = '0';
		}
		let state = this.state;
		state.viewImport = value;
		this.setState(state);
	}
	validatePermissions = () => {
		return this.state.formsFunctionalities.excel &&	this.state.isAllowedToDownloadForms &&
			!this.state.showPdfConverter && (this.state.urlFromPdf && this.isPartnerAndHasPermission())
	}
	render() {
		return (
			<>
				{this.state.showUpdateMessage && (
					<UpdateDocumentMessage
						{...this.props}
						handleClose={this.handleCloseUpdate}
						updateFileConfirm={this.updateFileConfirm}
						message={this.props.lan.updateTemplateMessagePdf}
					/>
				)}
				{this.state.showMessageSuccessAprove && (
					<ErrorMessage
						{...this.props}
						closeErrorMessage={() => this.closeErrorMessageAprove()}
						message={this.state.messageApproved}
						showErrorMessage={true}
						icon={this.state.iconMessage}
					/>
				)}
				<DowloadFormTemplate
					setViewImport={this.setViewImport}
					viewImport={this.state.viewImport}
					idFormTemplate={this.props.forms ? this.props.forms[this.state.activeForm]?.id : 0}
					nameFormTemplate={this.props.forms ? this.props.forms[this.state.activeForm]?.name: ""}
				/>
				<Scrollbars renderThumbHorizontal={(props) => <div {...props} style={{ display: 'none' }} />}>
					<Container>
						{this.state.show.editForm && (
							<EditForm
								form={this.props.forms[this.state.activeForm]}
								onClose={this.editFormVisibility}
								Header={this.FormHeader}
								taskId={this.props.taskData.idFielder}
								reloadData={this.props.reloadData}
								session={this.props.session}
								client={this.props.client}
								{...this.props}
							/>
						)}
						{this.state.show.generatePdfFromXlsx && (
							<GeneratePdfFromXlsx
								onClose={this.editPdfFromXlsxVisibility}
								urlGeneratePdfFromXlsx={this.state.urlGeneratePdfFromXlsx}
								approve={this.approveDocument}
								cancel={this.editPdfFromXlsxVisibility}
								{...this.props}
							/>
						)}
						{this.state.show.reactivateForm != null && (
							<ReactivateForm
								onClose={() => this.reactivateFormPopup(null)}
								reactivateForm={() => this.reactivateForm(this.state.show.reactivateForm)}
								{...this.props}
							/>
						)}
						{this.state.show.removeTaskForm != null && (
							<RemoveFormPopup
								onClose={() => this.removeTaskFormPopup(null)}
								removeFormTask={() => this.removeFormTask(this.state.show.removeTaskForm)}
								{...this.props}
							/>
						)}
            {((this.state.forms && this.state.forms.length > 0 && this.hasFinishForms()) || this.state.inventory || this.state.assets) &&
              !this.props.client && (
              <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center"}}>
                <Grid size={4}>
                  <Button
                    variant="contained"
                    size={'medium'}
                    fullWidth
                    id={'generate-pdf-form-module'}
                    startIcon={<SaveAltIcon />}
                    onClick={this.generateModulesZip}
                  >
                    {this.props.lan.generateZip}
                  </Button>
                </Grid>
              </Grid>
            )}
						{this.state.assets && this.state.assets.length > 0 && !this.props.client && (
							<React.Fragment>
								{this.state.isAllowedToViewAsset && (
									/*<Grid container className='my-5'>
										<div className='col-auto '>
											<img src={AssetsIcon} className='TaskModules-img' alt='' />
										</div>
										<div className='col-auto d-flex align-items-end'>{this.props.lan.assetManagement}</div>
										<div className='col d-flex flex-row-reverse'>
											{this.state.view.assets && (
												<img
													id='task-module-asset-dropdown'
													src={DropdownIcon}
													className='Fielder-icon-button'
													onClick={() => this.changeView('assets')}
													alt=''
												/>
											)}
											{!this.state.view.assets && (
												<img
													id='task-module-asset-dropup'
													src={DropRigth}
													className='Fielder-icon-button'
													onClick={() => this.changeView('assets')}
													alt=''
												/>
											)}
										</div>
									</Grid>*/
                  <Grid
                    container
                    alignItems="center"
                    sx={(theme) => ({ my: 1, py: 1, px: 1, borderBottom: `1px solid ${theme.palette.divider}`, gap: 1, })}
                  >
                    {/* Left icon */}
                    {/*<Grid size="auto" sx={{ display: 'flex', alignItems: 'center', }}>
                      <Box component="img" src={AssetsIcon} alt="" sx={{ width: 40, height: 40, objectFit: 'contain', }} />
                    </Grid>*/}
                    {/* Title */}
                    <Grid size="auto" sx={{ display: 'flex', alignItems: 'flex-end', ml: 4 }}>
                      <SmartTitleTypography variant={'subtitle1'}>{this.props.lan.assetManagement}</SmartTitleTypography>
                    </Grid>
                    {/* Toggle icon – right aligned */}
                    <Grid size="grow" sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', }}>
                      <IconButton
                        id={this.state.view.assets ? 'task-module-asset-dropdown' : 'task-module-asset-dropup'}
                        onClick={() => this.changeView('assets')}
                        sx={(theme) => ({ p: 0.5, '&:hover': { backgroundColor: theme.palette.action.hover, }, })}
                      >
                        {this.state.view.assets ? (
                          <KeyboardArrowDownIcon sx={{ width: 36, height: 36, }} />
                        ) : (
                          <KeyboardArrowRightIcon sx={{ width: 36, height: 36, }} />
                        )}
                      </IconButton>
                    </Grid>
                  </Grid>
								)}
								{this.state.view.assets && (
									<TaskAssets
										assets={this.state.assets}
										activeAsset={this.state.activeAsset}
										assetHasImages={this.state.assetHasImages}
										images={this.state.assetImages}
										changeActiveAsset={this.changeActiveAsset}
										client={this.props.client}
										timezone={this.props.taskData.startLocation.timeZone}
										taskData={this.props.taskData}
										taskAgent={this.props.taskAgent}
										reloadData={this.props.reloadData}
										idAccountTask={this.props.idAccountTask}
									/>
								)}
							</React.Fragment>
						)}
						{this.state.inventory && this.state.inventory.length > 0 && !this.props.client && (
							<React.Fragment>
								{this.state.isAllowedToViewInventory && (
									/*<Grid container className='my-5'>
										<div className='col-auto'>
											<img src={InventoryIcon} className='TaskModules-img' alt='' />
										</div>
										<div className='col-auto d-flex align-items-end'>{this.props.lan.inventories}</div>
										<div className='col d-flex flex-row-reverse'>
											{this.state.view.inventory && (
												<img
													id='task-module-inventory-dropdown'
													src={DropdownIcon}
													className='Fielder-icon-button'
													onClick={() => this.changeView('inventory')}
													alt=''
												/>
											)}
											{!this.state.view.inventory && (
												<img
													id='task-module-inventory-dropup'
													src={DropRigth}
													className='Fielder-icon-button'
													onClick={() => this.changeView('inventory')}
													alt=''
												/>
											)}
										</div>
									</Grid>*/
                  <Grid
                    container
                    alignItems="center"
                    sx={(theme) => ({ my: 1, py: 1, px: 1, borderBottom: `1px solid ${theme.palette.divider}`, gap: 1, })}>
                    {/* Left Icon */}
                    {/*<Grid size="auto" sx={{ display: "flex", alignItems: "center", }}>
                      <Box component="img" src={InventoryIcon} alt="" sx={{ width: 40, height: 40, objectFit: "contain", }} />
                    </Grid>*/}
                    {/* Title */}
                    <Grid size="auto" sx={{ display: "flex", alignItems: "flex-end", ml: 4, }}>
                      <SmartTitleTypography variant="subtitle1">{this.props.lan.inventories}</SmartTitleTypography>
                    </Grid>
                    {/* Toggle Button */}
                    <Grid size="grow" sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
                      <IconButton
                        id={this.state.view.inventory ? "task-module-inventory-dropdown" : "task-module-inventory-dropup"}
                        onClick={() => this.changeView("inventory")}
                        sx={(theme) => ({ p: 0.5, "&:hover": { backgroundColor: theme.palette.action.hover }, })}
                      >
                        {this.state.view.inventory ? (
                          <KeyboardArrowDownIcon sx={{ width: 36, height: 36, }} />
                        ) : (
                          <KeyboardArrowRightIcon sx={{ width: 36, height: 36, }} />
                        )}
                      </IconButton>
                    </Grid>
                  </Grid>
                )}
								{this.state.view.inventory && (
									<TaskInventories
										inventories={this.state.inventory}
										activeInventory={this.state.activeInventory}
										inventoryHasImages={this.state.inventoryHasImages}
										images={this.state.inventoryImages}
										changeActiveInventory={this.changeActiveInventory}
										client={this.props.client}
										timezone={this.props.taskData.startLocation.timeZone}
										taskData={this.props.taskData}
										taskAgent={this.props.taskAgent}
										reloadData={this.props.reloadData}
										idAccountTask={this.props.idAccountTask}
									/>
								)}
							</React.Fragment>
						)}
						{this.state.forms && this.state.forms.length > 0 && this.state.isAllowedToViewForm && (
              /*<Grid container>
								<div className='col-auto'>
									<img src={FormIcon} className='TaskModules-img' alt='' />
								</div>
								<div className='col-auto d-flex align-items-end'>{this.props.lan.forms}</div>
								<div className='col d-flex flex-row-reverse'>
									{this.state.view.forms && (
										<img
											id='task-module-forms-dropdown'
											src={DropdownIcon}
											className='Fielder-icon-button'
											onClick={() => this.changeView('forms')}
											alt=''
										/>
									)}
									{!this.state.view.forms && (
										<img
											id='task-module-forms-dropup'
											src={DropRigth}
											className='Fielder-icon-button'
											onClick={() => this.changeView('forms')}
											alt=''
										/>
									)}
								</div>
							</Grid>*/
              <Grid container
                    alignItems="center"
                    sx={(theme) => ({ my: 1, py: 1, px: 1, borderBottom: `1px solid ${theme.palette.divider}`, gap: 1, })}>
                {/* Icon */}
                {/*<Grid size="auto" sx={{ display: 'flex', alignItems: 'center', }}>
                  <Box component="img" src={FormIcon} alt="" sx={{ width: 40, height: 40, objectFit: 'contain', }} />
                </Grid>*/}
                {/* Title */}
                <Grid size="auto" sx={{ display: 'flex', alignItems: 'flex-end', ml: 4 }}>
                  <SmartTitleTypography variant={'subtitle1'}>{this.props.lan.forms}</SmartTitleTypography>
                </Grid>
                {/* Toggle button (right aligned) */}
                <Grid size="grow" sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', }}>
                  <IconButton
                    id={this.state.view.forms ? 'task-module-forms-dropdown' : 'task-module-forms-dropup'}
                    onClick={() => this.changeView('forms')}
                    sx={(theme) => ({ p: 0.5, '&:hover': { backgroundColor: theme.palette.action.hover }, })}
                    size={'large'}
                  >
                    {this.state.view.forms ? (
                      <KeyboardArrowDownIcon sx={{ width: 36, height: 36, }} />
                    ) : (
                      <KeyboardArrowRightIcon sx={{ width: 36, height: 36, }} />
                    )}
                  </IconButton>
                </Grid>
              </Grid>
						)}
						{this.state.view.forms && this.state.forms && this.state.forms.length > 0 && (
							<div style={this.props.client ? { height: '100%' } : { height: '60%' }} className='mt-4'>
								{RoleUtils.isUserManager(this.props.session.user) && (
									<Grid container>
                    <Grid size={'auto'} className='d-flex justify-content-end pb-1'>
                      <Button
                        variant='outlined'
                        size='small'
                        className='m-1'
                        onClick={() => this.setViewImport(true)}
                        startIcon={<img src={uploadButton} alt='' />}
                        sx={{ color: DeepSpaceGrey, border: `1px solid ${DeepSpaceGrey}` }}
                      >
                        {this.props.lan.updateTemplateForm}
                      </Button>
                    </Grid>
									</Grid>
								)}
								<Grid container sx={{ height: '70%', minHeight: '300px' }}>
									<Grid size={3}>
										<Scrollbars renderThumbHorizontal={(props) => <div {...props} style={{ display: 'none' }} />}>
											<this.FormTitles />
										</Scrollbars>
									</Grid>
									<Grid size={9}>
										<Scrollbars renderThumbHorizontal={(props) => <div {...props} style={{ display: 'none' }} />}>
											<this.FormHeader />
											<this.createFieldsForm />
										</Scrollbars>
									</Grid>
								</Grid>
                {this.state.forms && !this.props.client &&  (
                  <Grid container spacing={1} direction="row" sx={{ alignItems: "center" }}>
                    <Grid size={4}>
                      {this.props.hasFormsFunctionality && !RoleUtils.isUserManager(this.props.session.user) && this.getShowViewForm() && (
                        <Button
                          variant="outlined"
                          size={"medium"}
                          onClick={this.viewForm}
                        >
                          {this.props.lan.viewForm}
                        </Button>
                      )}
                    </Grid>
                    {((this.props.forms && this.props.forms[this.state.activeForm] &&  this.props.forms[this.state.activeForm].status === 'FINISHED') || this.props.allowGenerateFormsIfTaskStatusWasModify) && (
                    <Grid size={8}>
                      <Grid container spacing={1}>
                          {((this.state.formsFunctionalities.excel && this.state.isAllowedToDownloadForms) ||
                            (this.state.formsFunctionalities.excel && RoleUtils.isUserManager(this.props.session.user)
                              && this.state.allowManagerToDownloadFormExcelTaskDetail)) &&
                              this.isPartnerAndHasPermission() && this.getAllowPartnerGenerateXlsxForm() && (
                            <Grid size={'auto'}>
                              <Button
                                variant="contained"
                                fullWidth
                                size={'small'}
                                id='generate-pdf-xslx-form-module'
                                onClick={() => this.generateXlsx(false)}
                              >
                                {this.props.lan.generateXlsxModule}
                              </Button>
                          </Grid>
                        )}
                        {this.state.formsFunctionalities.excel &&
                          (this.state.isAllowedToDownloadForms || this.validateManagerGeneratePdf()) &&
                            this.state.showPdfConverter &&
                            this.isPartnerAndHasPermission() &&  this.getAllowPartnerGenerateTemplatePdf() && (
                            <Grid size={'auto'}>
                              <Button
                                variant="contained"
                                fullWidth
                                size={'small'}
                                id='generate-pdf-from-xlsx-form-module'
                                onClick={() => this.generateXlsx(true)}
                                disabled={this.state.disablePdfTemplateButton}>
                                {this.state.disablePdfTemplateButton
                                  ? this.props.lan.generatedPDFfromXlsx
                                  : this.props.lan.generatePDFfromXlsx}
                              </Button>

                            </Grid>
                          )}
                        {this.validatePermissions() &&  (
                            <Grid size={'auto'}>
                              <Button
                                variant="contained"
                                fullWidth
                                size={'small'}
                                id='generate-pdf-form-module'
                                style={{ fontSize:'8px' }}
                                onClick={this.redirectToMarketPlace}
                              >
                                {this.props.lan.buyGeneratePDFfromXlsx}
                              </Button>
                            </Grid>
                            )}
                          {this.state.urlFromPdf && this.isPartnerAndHasNotPermission()  &&  (
                            <Grid size={'auto'}>
                              <div style={{ fontWeight: 'bold' }}>{this.props.lan.download}</div>
                              <img
                                className='Fielder-icon-button sizeIconDocumentDownload buttonSizePage'
                                src={ExportIcon}
                                alt=''
                                onClick={() => {
                                  window.open(this.state.urlFromPdf, '_blank').focus();
                                }}
                                />
                          </Grid>
                          )}
                          {/*Aqui*/}
                        {(this.state.isAllowedToDownloadForms || RoleUtils.isUserManager(this.props.session.user))&& this.isPartnerAndHasPermission() && this.getAllowPartnerGenerateTemplatePdfFielder() && (
                            <Grid size={'auto'}>
                              <Button
                                variant="contained"
                                fullWidth
                                size={'small'}
                                id='generate-pdf-form-module'
                                onClick={this.generatePDF}
                              >
                                {this.props.lan.generatePDFModule}
                              </Button>
                          </Grid>
                        )}
                        {this.state.formHasImages && (
                            <Grid size={'auto'}>
                              <Button
                                variant="contained"
                                fullWidth
                                size={'small'}
                                id='download-form-images'
                                onClick={this.handlerDownloadImg}
                              >
                                {this.props.lan.downloadImages}
                              </Button>
                          </Grid>
                        )}
                      </Grid>
                      {this.state.formsFunctionalities.excel &&
                        (this.state.isAllowedToDownloadForms || this.validateManagerGeneratePdf()) &&
                          this.state.showPdfConverter &&
                          this.state.showUpdateComponentPdf
                            && this.isPartnerAndHasPermission() && (
                          <>
                              { this.getAllowPartnerUpdateTemplatePdf()  && (
                                <div className='row mt-2 d-flex justify-content-end'>
                                  <div className='col-auto'>
                                    <UpdateFileMenu
                                      key={'row-docUpdate'}
                                      idAccountFile={this.props.idAccountTask}
                                      idFile={this.state.idFilePdf}
                                      fileUrl={this.state.urlFromPdf}
                                      originType={0}
                                      updateFileHandler={this.updateFileHandler}
                                      dontShowLink={true}
                                      acceptFiles={ACCEPT_FILES}
                                    />
                                  </div>
                                  {this.isPartnerAndHasPermission() && (<Grid size={3}></Grid>)}
                                  {this.state.formHasImages && <Grid size={3}></Grid>}
                                </div>
                              )}
                            {this.getAllowPartnerDownloadTemplatePdf() && (
                              <div className='row d-flex justify-content-end'>
                                <div className='col-auto mt-2'>
                                  <div style={{ fontWeight: 'bold' }}>{this.props.lan.download}</div>
                                </div>
                                <div className='col-auto mt-1 pl-0'>
                                  <img
                                    className='Fielder-icon-button sizeIconDocumentDownload buttonSizePage'
                                    src={ExportIcon}
                                    alt=''
                                    onClick={() => {
                                      window.open(this.state.urlFromPdf, '_blank').focus();
                                    }}
                                  />
                                </div>
                                {this.isPartnerAndHasPermission() && (<Grid size={3}></Grid>)}
                                {this.state.formHasImages && <Grid size={3}></Grid>}
                              </div>
                            )}
                          </>
                        )}
                    </Grid>
                    )}
                  </Grid>
                )}
							</div>
						)}
					</Container>
				</Scrollbars>
			</>
		);
	}
}
const mapStateToProps = (state) => ({
	session: state.utils.session,
});
export default connect(mapStateToProps)(withRouter(TaskModules));
